import { platformLabel } from '../../layout/authorized/org/node/common/platform/platforms'

// An asset's DataType in plain words (owner 2026-10-09): the one map every
// audit screen reads. The raw type stays in an entry's Details.
//
// The platform names are "Available on"'s own (platforms.js): Web, Windows,
// Android, macOS, iOS, visionOS. A build is "<platform> build", its
// assembly "<platform> code", its overview "<platform> overview".

// The DataType's platform prefix -> the capsule's platform key.
const PLATFORM_OF = {
  WEB: 'web',
  STANDALONE: 'windows',
  STANDALONE_WIN: 'windows',
  STANDALONE_MAC: 'mac',
  IOS: 'ios',
  ANDROID: 'android',
  VISION_OS: 'visionos'
}

// A platform key's name ('android' -> "Android"); '' for none.
export const platformName = platformLabel

// The rest, by type. phrase: how it reads inside a sentence ("the scene
// source"); a platform's name keeps its capital.
const NAMED = {
  SCENE_ZIP: { name: 'Scene source', kind: 'scene' },
  THUMBNAIL: { name: 'Thumbnail', kind: 'thumbnail' },
  SNAPSHOT: { name: 'Saved progress', kind: 'snapshot' },
  COURSE_MEDIA: { name: 'Course media', kind: 'media' },
  COURSE_PREFABS: { name: 'Course prefabs', kind: 'media' },
  CATEGORY_IMAGE: { name: 'Folder picture', kind: 'picture' },
  COURSE_IMAGE: { name: 'Course picture', kind: 'picture' },
  AI_DOCUMENT: { name: 'AI document', kind: 'document', phrase: 'AI document' },
  HEATMAP_STEP_OBJ: { name: 'Heatmap model', kind: 'media' }
}

const SUFFIX = [
  ['_CONTENT', 'build', 'build'],
  ['_ASSEMBLY', 'code', 'code'],
  ['_OVERVIEW', 'overview', 'overview']
]

const words = code => {
  const s = String(code || '').replace(/[_-]+/g, ' ').trim().toLowerCase()
  return s ? s[0].toUpperCase() + s.slice(1) : ''
}

const lowerFirst = s => (s ? s[0].toLowerCase() + s.slice(1) : s)

// { name, phrase, kind, platform } for a DataType, or null for none. kind:
// build, code, overview, scene, thumbnail, snapshot, picture, media,
// document or other. An unknown type reads as its words.
export const dataTypeView = type => {
  const t = String(type || '').trim().toUpperCase()
  if (!t) return null
  if (NAMED[t]) {
    const n = NAMED[t]
    return { name: n.name, phrase: n.phrase || lowerFirst(n.name), kind: n.kind, platform: null }
  }
  for (const [suffix, word, kind] of SUFFIX) {
    if (t.endsWith(suffix)) {
      const key = PLATFORM_OF[t.slice(0, -suffix.length)]
      const platform = key ? platformName(key) : ''
      if (platform) return { name: `${platform} ${word}`, phrase: `${platform} ${word}`, kind, platform: key }
    }
  }
  const name = words(t)
  return { name, phrase: lowerFirst(name), kind: 'other', platform: null }
}

export const dataTypeName = type => (dataTypeView(type) || { name: '' }).name

// A size in bytes as people read it: "207 MB", "1.2 GB", "950 KB".
export const sizeText = bytes => {
  const n = Number(bytes)
  if (!Number.isFinite(n) || n <= 0) return ''
  const units = ['bytes', 'KB', 'MB', 'GB', 'TB']
  let v = n
  let i = 0
  while (v >= 1000 && i < units.length - 1) {
    v /= 1000
    i += 1
  }
  const shown = i === 0 || v >= 100 ? Math.round(v) : Number(v.toFixed(1))
  return `${shown.toLocaleString('en-US')} ${units[i]}`
}
